import "@/assets/less/animation.css";
import { getAction, postAction } from "@/api/manage";
import EventApplyModal from "../modal/EventApplyModal";
import SubmitWorkModal from "../modal/SubmitWorkModal";
import { filterMultiDictText } from '@/components/jeecg/JDictSelectUtil';
import { loadCategoryData } from '@/api/api';
export default {
  name: "Event",
  components: {
    EventApplyModal: EventApplyModal,
    SubmitWorkModal: SubmitWorkModal
  },
  data: function data() {
    return {
      dataSource: [],
      dictOptions: [],
      pagination: {
        onChange: function onChange(page) {
          console.log(page);
        },
        pageSize: 6
      }
    };
  },
  created: function created() {
    var _this = this;
    loadCategoryData({
      code: "A05"
    }).then(function (res) {
      if (res.success) {
        _this.$set(_this.dictOptions, 'eventCategory', res.result);
      }
    });
    this.getMyApplyEvent();
  },
  methods: {
    getDictValue: function getDictValue(text) {
      return filterMultiDictText(this.dictOptions['eventCategory'], text);
    },
    getMyApplyEvent: function getMyApplyEvent() {
      var _this2 = this;
      getAction("/teaching/teachingEventApply/myApply").then(function (res) {
        if (res.success) {
          _this2.dataSource = res.result;
        }
      });
    },
    toEventDetail: function toEventDetail(item) {
      var route = this.$router.resolve({
        path: "/event/detail",
        query: {
          id: item.eventId
        }
      });
      window.open(route.href, '_blank');
    },
    download: function download(url) {
      window.open(url + "?t=" + new Date().getTime());
    },
    toOrder: function toOrder() {
      this.$router.push({
        path: '/user/order'
      });
    },
    submitOk: function submitOk() {
      this.getMyApplyEvent();
    },
    showApplyEvent: function showApplyEvent(applyInfo) {
      this.$refs.applyModal.open(applyInfo.eventId, applyInfo.myEventCategory);
    },
    showSubmitWork: function showSubmitWork(info) {
      var h = this.$createElement;
      if (info.takePartType == 2) {
        this.$success({
          title: "提示",
          content: h("div", [h("p", ["\u7EBF\u4E0B\u6D3B\u52A8\u62A5\u540D\u6210\u529F\u540E\u76F4\u63A5\u63D0\u793A\u51ED\u8BC1\u4EF6\u524D\u5F80\uFF01"])])
        });
      } else {
        this.$refs.submitModal.open(info);
      }
    },
    toPaper: function toPaper(item) {
      var route = this.$router.resolve({
        path: "/examine",
        query: {
          eaid: item.id
        }
      });
      window.open(route.href, '_blank');
    },
    toScore: function toScore(eventApplyId) {
      window.open("/cert/score.html?id=" + eventApplyId);
    },
    toCert: function toCert(certId) {
      window.open("/cert/query?id=" + certId);
    }
  }
};